import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { shouldShowMediaProgress } from './media-progress-bar';
import { getMediumProgressPercentage } from '@fec/assets/js/utils/media-progress';
import { MEDIA_TIME_UPDATE, onEvent } from '@fec/assets/js/utils/event';
import DebounceHelper from '@fec/frontend/foundation/client/debounce-helper';

const MediaProgressBar = ({ urn }) => {
  const progressPercentage = getMediumProgressPercentage(urn);

  if (progressPercentage === 0 || !shouldShowMediaProgress()) {
    return null;
  }

  return <ProgressBar progress={progressPercentage} />;
};

MediaProgressBar.propTypes = {
  urn: PropTypes.string.isRequired,
};

export const SelfUpdatingMediaProgressBar = ({ urn }) => {
  const [progressPercentage, setProgressPercentage] = useState(0);

  useEffect(() => {
    onEvent({
      eventName: MEDIA_TIME_UPDATE,
      eventHandler: DebounceHelper.throttle(({ detail }) => {
        if (detail.urn === urn) {
          setProgressPercentage(detail.percentage);
        }
      }, 1000),
    });
  }, [urn]);

  return <ProgressBar progress={progressPercentage} />;
};

// in: 2 x DateTime string, e.g. '2024-08-15T08:55:00+02:00'
// out: percentage of time passed between start and end time
export const calculateProgressByStartAndEndTime = (start, end) => {
  // Provided time values
  const startTime = new Date(start);
  const endTime = new Date(end);
  const currentTime = new Date();

  // Total duration between startTime and endTime in milliseconds
  const totalDuration = endTime - startTime;

  // Elapsed time from startTime to currentTime in milliseconds
  const elapsedTime = currentTime - startTime;

  // Calculate the progress percentage...
  let progress = (elapsedTime / totalDuration) * 100;

  // ...and make sure that the progress is between 0% and 100%
  return Math.max(0, Math.min(100, progress));
};

export const ProgressBar = ({ progress }) => (
  <div
    className="media-progress-bar"
    style={{ '--media-progress-bar-progress': progress }}>
    <div className="media-progress-bar__indicator" />
  </div>
);

export default MediaProgressBar;
